import { create } from "zustand";
import { db, getLobbyRef, getUserLobbiesRef, mapKeys } from "../lib/firebase";
import { useAuthStore } from "./auth.store";
import {
  equalTo,
  onValue,
  orderByChild,
  query,
  ref,
  set
} from "firebase/database";
import { Lobby, OpenLobby } from "../types/lobby";

interface lobbiesState {
  lobbies: Lobby[];
  openLobbies: OpenLobby[];
  activeChallenge?: string;
  loading: boolean;
  updateLobby: (id: string, key: string, value: Lobby | OpenLobby) => void;
  setActiveChallenge: (challengeId: string | undefined) => void;
}

export const useLobbiesStore = create<lobbiesState>(setState => ({
  lobbies: [],
  openLobbies: [],
  activeChallenge: undefined,
  loading: false,
  updateLobby: (id, key, value) => {
    const keyRef = ref(db, `lobbies/${id}/${key}`);
    set(keyRef, value);
  },
  setActiveChallenge: (challengeId: string | undefined) => {
    setState({ activeChallenge: challengeId });
  }
}));

const mapTotalPot = (lobbies: any) =>
  lobbies.map((lobby: any) => ({
    ...lobby,
    totalPot: lobby?.totalPot || lobby?.buyIn * lobby?.bots?.length || 0
  }));

const updateState = (lobbyId: string, lobby: any) => {
  useLobbiesStore.setState(({ lobbies, openLobbies }) =>
    lobbies.find(l => l.id === lobbyId)
      ? {
          lobbies: mapTotalPot(
            lobbies.map(lob => (lob.id === lobbyId ? lobby : lob))
          ),
          openLobbies,
          loading: false
        }
      : {
          lobbies: mapTotalPot([...lobbies, lobby]),
          openLobbies,
          loading: false
        }
  );
};

// OPEN LOBBIES
useAuthStore.subscribe(authState => {
  if (!authState.user) return;
  const lobbiesRef = ref(db, `lobbies/`);
  onValue(
    query(lobbiesRef, orderByChild("started"), equalTo(false)),
    snapshot => {
      useLobbiesStore.setState({ loading: true });
      const data = snapshot.val();
      if (data) {
        useLobbiesStore.setState(({ lobbies }) => ({
          lobbies,
          openLobbies: mapTotalPot(mapKeys(data)),
          loading: false
        }));
      }
    }
  );

  const userLobbiesRef: any = getUserLobbiesRef(authState.user.uid);
  onValue(userLobbiesRef, async (snapshot: any) => {
    const data = snapshot.val();
    if (data) {
      for (let lobbyId of data) {
        if (lobbyId) {
          const lobbyRef = getLobbyRef(lobbyId);
          onValue(lobbyRef, (snapshot: any) => {
            const lobby = snapshot.val();
            if (lobby) {
              lobby.id = lobbyId;
              updateState(lobbyId, lobby);
            }
          });
        }
      }
    }
  });
});

export const subscribeToLobby = (lobbyId: string) => {
  // console.log("subscribe lobby ", lobbyId);
  const lobbyRef = getLobbyRef(lobbyId);
  onValue(lobbyRef, snapshot => {
    const lobby = snapshot.val();
    if (lobby) {
      lobby.id = lobbyId;
      updateState(lobbyId, lobby);
    }
  });
};
